import { featureFlagOn } from '@dataroom/shared';

/** The Contracts tab and route (ADR-0054): on unless `VITE_FEATURE_CONTRACTS` is "0". */
export function contractsEnabled(): boolean {
  return featureFlagOn(import.meta.env.VITE_FEATURE_CONTRACTS as string | undefined);
}
